module.exports = __webpack_public_path__ + "static/Carpool-pic-a846a09e741f868c24da9608d1fbc483.svg";